import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import intersection from 'lodash/intersection';
import categoryQuery from '~/graphql/category.gql';
import categoriesQuery from '~/graphql/categories.gql';
import productsQuery from '~/graphql/products.gql';
import customizeProductQuery from '~/graphql/customizeProduct.gql';
import productPricesQuery from '~/graphql/product/prices.gql';
import TYPES from '~/const/editorial';
import { fetchDocumentsById } from '~/services/editorial';
var QUERIES = {
  productPrices: productPricesQuery,
  products: productsQuery,
  category: categoryQuery,
  categories: categoriesQuery,
  customized: customizeProductQuery
};

var componentList = function componentList() {
  var paths = TYPES.filter(function (e) {
    return e.path;
  });
  var slices = TYPES.filter(function (e) {
    return e.slices;
  }).map(function (e) {
    return e.slices;
  }).reduce(function (e, f) {
    return e.concat(f);
  }, []);
  return [].concat(_toConsumableArray(paths), _toConsumableArray(slices));
};

var typeDefinition = function typeDefinition(alias) {
  if (alias === 'null') {
    // When the alias is not defined in Prismic, it matches 'null' (/FR/fr/e/null/...)
    // In this case, we expect a 404
    return null;
  }

  return TYPES.find(function (e) {
    return e.aliases.includes(alias);
  }) || TYPES.find(function (e) {
    return e.type === 'generic';
  });
};

var sliceDefinition = function sliceDefinition(definition, slice) {
  return definition.slices.find(function (e) {
    return e.name === slice.slice_type;
  });
};

var supportedSlices = function supportedSlices(definition, slices) {
  var existing = definition.slices.map(function (e) {
    return e.name;
  });
  var defined = slices.map(function (e) {
    return e.slice_type;
  });
  return slices.filter(function (e) {
    return intersection(existing, defined).includes(e.slice_type);
  });
};

var buildCatalogPayload =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(_ref, slice, client, locale) {
    var query, handler, _ref3, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, handler = _ref.handler;
            _context.next = 3;
            return client.query({
              query: QUERIES[query],
              variables: _objectSpread({
                locale: locale
              }, handler(slice))
            });

          case 3:
            _ref3 = _context.sent;
            data = _ref3.data;
            return _context.abrupt("return", data);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function buildCatalogPayload(_x, _x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var buildEditorialArticle =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(slice, store) {
    var _ref5, results;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchDocumentsById(store, [slice.primary.article.id]);

          case 2:
            _ref5 = _context2.sent;
            results = _ref5.results;
            return _context2.abrupt("return", results);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function buildEditorialArticle(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

var buildSlices = function buildSlices(definition, _ref6, client, store) {
  var body = _ref6.body;
  var currentSlices = supportedSlices(definition, body);
  return Promise.all(currentSlices.map(
  /*#__PURE__*/
  function () {
    var _ref7 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(slice, position) {
      var _sliceDefinition, path, additional, article;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _sliceDefinition = sliceDefinition(definition, slice), path = _sliceDefinition.path, additional = _sliceDefinition.additional, article = _sliceDefinition.article;
              _context3.t0 = position;
              _context3.t1 = path;
              _context3.t2 = slice.slice_type;
              _context3.t3 = slice;

              if (!additional) {
                _context3.next = 11;
                break;
              }

              _context3.next = 8;
              return buildCatalogPayload(additional, slice, client, store.state.i18n.currentLocale.iso);

            case 8:
              _context3.t4 = _context3.sent;
              _context3.next = 12;
              break;

            case 11:
              _context3.t4 = null;

            case 12:
              _context3.t5 = _context3.t4;

              if (!article) {
                _context3.next = 19;
                break;
              }

              _context3.next = 16;
              return buildEditorialArticle(slice, store);

            case 16:
              _context3.t6 = _context3.sent;
              _context3.next = 20;
              break;

            case 19:
              _context3.t6 = null;

            case 20:
              _context3.t7 = _context3.t6;
              _context3.t8 = {
                editorial: _context3.t3,
                catalog: _context3.t5,
                article: _context3.t7
              };
              return _context3.abrupt("return", {
                position: _context3.t0,
                path: _context3.t1,
                type: _context3.t2,
                payload: _context3.t8
              });

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x7, _x8) {
      return _ref7.apply(this, arguments);
    };
  }()));
};

export { componentList, typeDefinition, buildSlices };